import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PartResultModel } from 'app/models/dms/partResult.model';
import { Constants } from 'app/utility/constants';
import { Observable } from 'rxjs';
import { CacheService } from './cache.service';

@Injectable({
  providedIn: 'root'
})
export class PartService
{

  constructor(private httpClient: HttpClient, private cache: CacheService) { }

  getParts(): Observable<PartResultModel[]>
  {
    let httpParams = new HttpParams();

    return this.httpClient.get<PartResultModel[]>(Constants.ApiUrl + 'Parts', { params: httpParams });
  }

  getCachedParts(): Observable<PartResultModel[]>
  {
    let cacheKey: string = 'parts';
    let cacheMilliseconds: number = 1 * 60 * 60000; //1 hour
    return this.cache.get(cacheKey, this.getParts(), cacheMilliseconds);
  }
}
